import { InteractionType, EventSource, MixpanelEvent, ComponentType } from '../MixPanelTypes';

export type DuplicateSearchEvents =
  | 'SEARCH_RUN'
  | 'MATCH_DETECTED'
  | 'DNR_FLAGGED'
  | 'MARKED_NO_MATCH'
  | 'MATCHED_AND_MERGED'
  | 'DNR_OVERRIDDEN';

export const duplicateSearchEvents: Record<DuplicateSearchEvents, MixpanelEvent> = {
  // System: a duplicate search completed for a candidate.
  SEARCH_RUN: {
    eventDescription: 'Duplicate Search Run',
    eventKey: 'duplicate-search-run',
    eventSource: EventSource.USER_EFFECT,
    interactionType: InteractionType.N_A,
    componentType: ComponentType.N_A
  },
  // System: a potential match was detected. Broken out by confidence via the `confidence` detail.
  MATCH_DETECTED: {
    eventDescription: 'Duplicate Search Match Detected',
    eventKey: 'duplicate-search-match-detected',
    eventSource: EventSource.SERVER_EVENT,
    interactionType: InteractionType.N_A,
    componentType: ComponentType.N_A
  },
  // System: the top match is flagged as Do Not Rehire (rehire ineligible).
  DNR_FLAGGED: {
    eventDescription: 'Duplicate Search DNR Flagged',
    eventKey: 'duplicate-search-dnr-flagged',
    eventSource: EventSource.SERVER_EVENT,
    interactionType: InteractionType.N_A,
    componentType: ComponentType.N_A
  },
  // User outcome: reviewer marked the match as a different person (false positive). Reason via the `reason` detail.
  MARKED_NO_MATCH: {
    eventDescription: 'Duplicate Search Marked No Match',
    eventKey: 'duplicate-search-marked-no-match',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.PRIMARY_ACTION
  },
  // User outcome: reviewer confirmed the match and merged the records.
  MATCHED_AND_MERGED: {
    eventDescription: 'Duplicate Search Matched And Merged',
    eventKey: 'duplicate-search-matched-and-merged',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.PRIMARY_ACTION
  },
  // User outcome: reviewer submitted the task without rejecting despite a DNR-flagged match.
  DNR_OVERRIDDEN: {
    eventDescription: 'Duplicate Search DNR Overridden',
    eventKey: 'duplicate-search-dnr-overridden',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.PRIMARY_ACTION
  }
} as const;
